import React from "react";

// Component Imports
import StatusCircleFill from "../StatusCircleFill/StatusCircleFill";
import { capitalizeFirstChars } from "@pulse-ui/formatting";

const OrderStatusCell: React.FC<{
  value: string | null | undefined;
  cum_qty: string | null | undefined;
  order_qty: string | null | undefined;
}> = React.memo(({ value, cum_qty, order_qty }) => {
  const formattedValue =
    value && value.length > 0
      ? capitalizeFirstChars(value.toString().split("_"))
      : "";

  const grabStatusColors = () => {
    if (formattedValue) {
      switch (formattedValue) {
        case "Cancelled":
          return { class: "pulse-color--background-300", hex: "#f2f07e" };
        case "Expired":
          return { class: "pulse-color--background-300", hex: "#627195" };
        case "Filled":
          return { class: "pulse-color--success-300", hex: "#64e087" };
        case "New":
          return { class: "pulse-color--background-50", hex: "#e8eaef" };
        case "Partially Filled":
          return { class: "pulse-color--success-300", hex: "#64e087" };
        case "Pending Cancel":
          return { class: "pulse-color--background-50", hex: "#e8eaef" };
        case "Pending New":
          return { class: "pulse-color--background-50", hex: "#e8eaef" };
        case "Rejected":
          return { class: "pulse-color--error-200", hex: "#ff8f95" };
        default:
          return { class: "pulse-color--background-200", hex: "#939db6" };
      }
    }

    return { class: "pulse-color--background-100", hex: "#b6bdce" };
  };

  const generate_percentage_filled = (
    cum_qty: string | null | undefined,
    order_qty: string | null | undefined
  ) => {
    const parsed_cum_qty = parseFloat(cum_qty || "0");
    const parsed_order_qty = parseFloat(order_qty || "0");

    if (parsed_order_qty === 0) return 0;

    return (parsed_cum_qty / parsed_order_qty) * 100;
  };

  return (
    <div className={`pulse-status-text ${grabStatusColors().class}`}>
      <StatusCircleFill
        percentage={generate_percentage_filled(cum_qty, order_qty)}
        primaryColor={grabStatusColors().hex}
        backgroundColor="#0c1835"
      />
      <p className={`pulse-typography-body-1 ${grabStatusColors().class}`}>
        {formattedValue}
      </p>
    </div>
  );
});

export default OrderStatusCell;
